import { AddressForm, BackButton, Form, FormInput, FormTextArea, Label, useAlignments } from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialLossPayee = (props) => {
    const alignments = useAlignments();
    const [mode] = useState('lossPayeeView');

    const changeAddress = (dotProp, value) => {
        if (dotProp === 'address') {
            props.doReducePolicyElement({ code: `${props.dotProp}address`, value });
        } else {
            props.doReducePolicyElement({ code: `${props.dotProp}address.${dotProp}`, value });
        }
    };

    const saveAddressHandler = () => {
        props.doUpsertPolicy();
    };

    return (
        mode === 'lossPayeeView' && (
            <React.Fragment>
                <BackButton clickEvent={props.backEvent} />
                <Form
                    rowId={props.rowId}
                    pageCode={props.pageCode}
                    sectionCode='lossPayeesDetails'
                    saveTooltipInfo={props.saveTooltipInfo}
                    reduceTooltipInfoElement={props.reduceTooltipInfoElement}
                    tooltipInfo={props.tooltipInfo}
                    validationInfo={props.validationInfo}
                    header={props.lossPayee?.label}
                    label={<FormattedMessage id='Profile_SupernovaCommercial_LossPayees_LossPayee.lossPayeeDetails' />}
                    allowEdit={props.allowEdit}
                    saveEvent={() => props.doUpsertPolicy()}
                    cancelEvent={() => props.doGetPolicy()}
                >
                    <FormInput
                        fieldCode='legalBusinessName'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_LossPayees_LossPayee.businessName' />}
                        value={props.lossPayee?.legalBusinessName}
                        type='text'
                        changeEvent={(value) =>
                            props.doReducePolicyElement({ code: `${props.dotProp}legalBusinessName`, value })
                        }
                        allowEdit
                    />
                    <Label
                        bold
                        text={<FormattedMessage id='Profile_SupernovaCommercial_LossPayees_LossPayee.withRespectTo' />}
                        textAlign={alignments.left}
                    />
                    <FormTextArea
                        fieldCode='note'
                        text={props.lossPayee?.note}
                        changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}note`, value })}
                        allowEdit
                    />
                </Form>
                <AddressForm
                    {...props}
                    enableAddressSearch={true}
                    pageCode={props.pageCode}
                    sectionCode='lossPayeeAddressDetails'
                    saveTooltipInfo={() => props.doUpsertTooltipInfo(props.policy.product)}
                    reduceTooltipInfoElement={props.doReduceTooltipInfoElement}
                    tooltipInfo={props.tooltipInfo}
                    validationInfo={props.validationInfo}
                    addressSearchCountryCode='CAN'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_LossPayees_LossPayee.addressDetails' />}
                    label={<FormattedMessage id='Profile_SupernovaCommercial_LossPayees_LossPayee.locationDetails' />}
                    saveEvent={saveAddressHandler}
                    cancelEvent={props.doGetPolicy}
                    reference={props.reference}
                    changeEvent={(dotProp, value) => changeAddress(dotProp, value)}
                    allowEdit={props.allowEdit}
                    address={props.lossPayee?.address}
                />
            </React.Fragment>
        )
    );
};

export default ProfileSupernovaCommercialLossPayee;
